import type { WymhPlatform } from "@/mocks/wymh-content";

interface WymhPlatformCardProps {
  platform: WymhPlatform;
}

export default function WymhPlatformCard({ platform }: WymhPlatformCardProps) {
  return (
    <div className="flex flex-col h-full rounded-2xl bg-background-50 border border-background-200 p-6 md:p-7">
      <div className="flex items-center gap-4 mb-5">
        <span className="w-14 h-14 rounded-2xl bg-primary-50 border border-primary-100 flex items-center justify-center shrink-0">
          <i className={`${platform.icon} text-3xl text-primary-600`}></i>
        </span>
        <div>
          <h3 className="text-foreground-950 font-bold text-xl leading-tight">{platform.name}</h3>
          <p className="text-foreground-500 text-xs mt-1">{platform.size}</p>
        </div>
      </div>

      <ul className="flex flex-col gap-2 flex-1">
        <li className="flex items-center gap-2 text-sm text-foreground-600">
          <i className="ri-check-line text-accent-500 w-4 h-4 flex items-center justify-center"></i>
          {platform.requirement}
        </li>
        <li className="flex items-center gap-2 text-sm text-foreground-600">
          <i className="ri-check-line text-accent-500 w-4 h-4 flex items-center justify-center"></i>
          {platform.note}
        </li>
      </ul>
    </div>
  );
}